export { default } from './resolveProps';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/resolveProps/index.js
// module id = 229
// module chunks = 25